import { Pipe, PipeTransform } from '@angular/core';
import { AlphabetMapConstants } from '../constants/alphabet-map.constants';

@Pipe({ name: 'alphabet' })
export class AlphabetPipe implements PipeTransform {

  public transform(value: string, alphabet: string) {
    if (alphabet === 'cyrillic-mk') {
      return value.split('').map(c => this.toCyrillic(c)).join('');
    }
    return value;
  }

  toCyrillic(char: string) {
    return AlphabetMapConstants.latinToCyrillicMap[char] || char;
  }

}
